var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeotube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 980,
    height: 604,
    viewBox: "0 0 980 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.024 154.271C320.241 127.055 366.714 139.507 376.676 176.686L430.831 378.796C440.793 415.975 406.773 449.995 369.594 440.033L167.484 385.878C130.305 375.916 117.853 329.443 145.069 302.227L293.024 154.271Z",
    fill: "url(#paint0_linear_334_18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.359 155.853C277.604 122.519 325.717 122.519 344.962 155.853L449.582 337.06C468.827 370.393 444.77 412.06 406.28 412.06H197.04C158.55 412.06 134.494 370.393 153.739 337.06L258.359 155.853Z",
    fill: "url(#paint1_linear_334_18)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337.027 153.704C370.361 134.459 412.027 158.515 412.027 197.005L412.027 406.245C412.027 444.735 370.361 468.791 337.027 449.546L155.82 344.926C122.487 325.681 122.487 277.569 155.82 258.324L337.027 153.704Z",
    fill: "url(#paint2_linear_334_18)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.078 293.337C361.745 297.186 361.745 306.809 355.078 310.658L282.956 352.298C276.289 356.147 267.956 351.335 267.956 343.637L267.956 260.358C267.956 252.66 276.289 247.848 282.956 251.697L355.078 293.337Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M527.56 261H506.356L470.892 207.308V261H449.688V173.952H470.892L506.356 227.892V173.952H527.56V261ZM564.134 190.94V208.548H592.53V224.916H564.134V244.012H596.25V261H542.93V173.952H596.25V190.94H564.134Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M545.558 281.203V298.191H522.494V368.251H501.29V298.191H478.226V281.203H545.558ZM577.032 281.203V333.283C577.032 338.491 578.313 342.5 580.876 345.311C583.438 348.122 587.2 349.527 592.16 349.527C597.12 349.527 600.922 348.122 603.568 345.311C606.213 342.5 607.536 338.491 607.536 333.283V281.203H628.74V333.159C628.74 340.93 627.086 347.502 623.78 352.875C620.473 358.248 616.009 362.299 610.388 365.027C604.849 367.755 598.649 369.119 591.788 369.119C584.926 369.119 578.768 367.796 573.312 365.151C567.938 362.423 563.681 358.372 560.54 352.999C557.398 347.543 555.828 340.93 555.828 333.159V281.203H577.032ZM696.329 323.611C701.372 324.686 705.423 327.207 708.481 331.175C711.54 335.06 713.069 339.524 713.069 344.567C713.069 351.842 710.507 357.628 705.381 361.927C700.339 366.143 693.271 368.251 684.177 368.251H643.629V281.203H682.813C691.659 281.203 698.561 283.228 703.521 287.279C708.564 291.33 711.085 296.827 711.085 303.771C711.085 308.896 709.721 313.154 706.993 316.543C704.348 319.932 700.793 322.288 696.329 323.611ZM664.833 316.419H678.721C682.193 316.419 684.839 315.675 686.657 314.187C688.559 312.616 689.509 310.343 689.509 307.367C689.509 304.391 688.559 302.118 686.657 300.547C684.839 298.976 682.193 298.191 678.721 298.191H664.833V316.419ZM680.457 351.139C684.012 351.139 686.74 350.354 688.641 348.783C690.625 347.13 691.617 344.774 691.617 341.715C691.617 338.656 690.584 336.259 688.517 334.523C686.533 332.787 683.764 331.919 680.209 331.919H664.833V351.139H680.457ZM746.572 298.191V315.799H774.968V332.167H746.572V351.263H778.688V368.251H725.368V281.203H778.688V298.191H746.572Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 671.375,
    cy: 215.374,
    r: 58.3745,
    fill: "url(#paint3_linear_334_18)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.375,
    cy: 215.374,
    r: 58.3745,
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M670.17 263.354C661.44 263.354 653.385 261.329 646.005 257.279C638.715 253.139 632.91 247.424 628.59 240.134C624.36 232.754 622.245 224.474 622.245 215.294C622.245 206.114 624.36 197.879 628.59 190.589C632.91 183.299 638.715 177.629 646.005 173.579C653.385 169.439 661.44 167.369 670.17 167.369C678.99 167.369 687.045 169.439 694.335 173.579C701.715 177.629 707.52 183.299 711.75 190.589C715.98 197.879 718.095 206.114 718.095 215.294C718.095 224.474 715.98 232.754 711.75 240.134C707.52 247.424 701.715 253.139 694.335 257.279C687.045 261.329 678.99 263.354 670.17 263.354ZM670.17 249.989C676.38 249.989 681.915 248.594 686.775 245.804C691.635 242.924 695.415 238.874 698.115 233.654C700.905 228.344 702.3 222.224 702.3 215.294C702.3 208.364 700.905 202.289 698.115 197.069C695.415 191.849 691.635 187.844 686.775 185.054C681.915 182.264 676.38 180.869 670.17 180.869C663.96 180.869 658.425 182.264 653.565 185.054C648.705 187.844 644.88 191.849 642.09 197.069C639.39 202.289 638.04 208.364 638.04 215.294C638.04 222.224 639.39 228.344 642.09 233.654C644.88 238.874 648.705 242.924 653.565 245.804C658.425 248.594 663.96 249.989 670.17 249.989Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M688.032 211.176C690.4 212.76 690.4 216.24 688.032 217.824L666.225 232.418C663.567 234.197 660 232.292 660 229.094L660 199.906C660 196.708 663.567 194.803 666.225 196.582L688.032 211.176Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M316.281 295.913C321.006 298.596 321.006 305.404 316.281 308.087L291.707 322.043C287.04 324.693 281.25 321.322 281.25 315.956L281.25 288.044C281.25 282.678 287.04 279.307 291.707 281.957L316.281 295.913Z",
    fill: "#9517E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_18",
    x1: 340.689,
    y1: 144.993,
    x2: 239.965,
    y2: 519.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9517E2",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928557,
    stopColor: "#D7177F",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_18",
    x1: 301.998,
    y1: 134.554,
    x2: 301.66,
    y2: 522.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9517E2",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928557,
    stopColor: "#D7177F",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_334_18",
    x1: 385.469,
    y1: 157.078,
    x2: 191.222,
    y2: 492.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9517E2",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928557,
    stopColor: "#D7177F",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_334_18",
    x1: 671.464,
    y1: 171.197,
    x2: 671.374,
    y2: 273.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9517E2",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928557,
    stopColor: "#D7177F",
    stopOpacity: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeotube);
export default __webpack_public_path__ + "static/media/NEO TUBE.6e976096c82befee595fa31aa40ba936.svg";
export { ForwardRef as ReactComponent };